// CustomPaginationStyles.ts
import { styled } from '@mui/system'
import { type SelectProps, Stack, type Theme, Select } from '@mui/material'

import { grey, shade } from '../../../colors'

interface PaginationWrapperProps {
  theme?: Theme
}

export const PaginationWrapper = styled(Stack)<PaginationWrapperProps>(({ theme }) => ({
  borderTop: `1px solid ${shade[650]}`,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: `${theme.spacing(2)} ${theme.spacing(5)}`
}))

interface SelectPageSizeProps {
  theme?: Theme
}
export const SelectPageSize = styled(Select)<SelectPageSizeProps>(({ theme }) => ({
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  width: theme.spacing(30),
  borderRadius: theme.spacing(2),
  color: grey[950],
  fontSize: '14px',
  fontWeight: 'bold',
  '&:hover': {
    background: shade[750]
  }
}))
